import { Icon } from 'lucide-react'

import { type CustomLucideIconProps } from './props'

export function SolidCircleCheckIcon ({ color = 'currentColor', ...props }: CustomLucideIconProps) {
  return (
    <Icon {...props} fill={color} stroke='none' iconNode={[]}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711L10.7071 15.7071C10.3166 16.0976 9.68342 16.0976 9.29289 15.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929C6.68342 10.9024 7.31658 10.9024 7.70711 11.2929L10 13.5858L12.6464 10.9393L15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289Z'
      />
    </Icon>
  )
}
